module.exports = __webpack_public_path__ + "img/virusColectivo9.925417c6.jpg";